import BigNumber from 'bignumber.js';

import { DECIMAL_PLACES_SHORT, THOUSAND } from 'modules/common/const';

export function formatThousandAmount(
  amount: BigNumber,
  decimals = DECIMAL_PLACES_SHORT,
): string {
  if (amount.isGreaterThan(THOUSAND)) {
    return `${amount.div(THOUSAND).integerValue().toFormat()}K`;
  }

  return amount.decimalPlaces(decimals).toFormat();
}
